import { render, staticRenderFns } from "./Cl4UserInfo.vue?vue&type=template&id=679e7026"
import script from "./Cl4UserInfo.vue?vue&type=script&lang=js"
export * from "./Cl4UserInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports